import DatePicker from './src/date-picker.mjs';
export { datePickerProps } from './src/props.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElDatePicker = withInstall(DatePicker);

export { ElDatePicker, ElDatePicker as default };
//# sourceMappingURL=index.mjs.map
